import PageLayout from '../components/global/PageLayout';
import SetupGuide from '../components/onboarding/SetupGuide';
import useGetOnboarding from '../hooks/businesses/useGetOnboarding';

export default function GetStartedPage() {
  const { isEnabled } = useGetOnboarding();

  return (
    <PageLayout
      headerIsHidden
      withoutChildContainer
      guard={{ isAllowed: isEnabled }}>
      <SetupGuide />
    </PageLayout>
  );
}
